import type { SxProps, Theme } from '@mui/material';

import { BLUE, BLUE_TERTIARY } from 'constants/colors';

export const cellWrapperSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%'
};

export const cellBadgeSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 28,
  width: '100%',
  border: '1px solid',
  borderColor: BLUE,
  backgroundColor: BLUE_TERTIARY,
  borderRadius: '6px',
  color: 'text.primary',
  fontSize: '0.75rem',
  fontWeight: 500
};
